import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import * as MEDIA from 'styles/media-queries'

const { unit } = measures

export const container = css`
  background-color: ${colors.black100};

  overflow: auto;

  height: inherit;
  width: inherit;
`
// linear-gradient(,)
export const contentContainer = css`
  min-height: calc(100% - ${8 * unit}px);
  background: radial-gradient(
    circle at top,
    ${colors.black100},
    ${colors.grays.gray6}
  );
  width: inherit;
`

export const content = css`
  position: relative;

  ${MEDIA.NOT_PHONES} {
    padding: ${2 * unit}px ${8 * unit}px;
  }
`
